import type { ReactNode } from "react";
import { MeterBar } from "../../components/MeterBar.js";
import { StatIcon, type StatIconName } from "../../components/StatIcon.js";
import { StatHelpButton } from "./StatHelpButton.js";
import type { StatHelpTopic } from "./statHelp.js";

type CaseMeterRowProps = {
  label: string;
  icon: StatIconName;
  topic: StatHelpTopic;
  value: ReactNode;
  max: number;
  barValue: number;
  from?: number;
  glitterGain?: number;
  onHelp: (topic: StatHelpTopic) => void;
};

export function CaseMeterRow({
  label,
  icon,
  topic,
  value,
  max,
  barValue,
  from,
  glitterGain,
  onHelp,
}: CaseMeterRowProps) {
  return (
    <div className="progress-block">
      <div className="progress-label">
        <span className="meter-label">
          <StatIcon name={icon} />
          {label}
          <StatHelpButton topic={topic} onHelp={onHelp} />
        </span>
        <span className="meter-end">
          {value} / {max}
        </span>
      </div>
      <MeterBar
        key={from == null ? "bar" : `fill-${from}-${barValue}`}
        value={barValue}
        max={max}
        from={from}
        variant="progress"
        glitterGain={glitterGain}
      />
    </div>
  );
}
